"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkedIn = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var LinkedIn = function LinkedIn() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 2.743a2.743 2.743 0 115.486 0 2.743 2.743 0 01-5.486 0zm24 11.533a6.322 6.322 0 00-4.87-6.253 6.116 6.116 0 00-5.416 1.467v-.576a.686.686 0 00-.686-.686H9.6a.686.686 0 00-.686.686v13.714c0 .378.307.686.686.686h3.428a.686.686 0 00.686-.686v-7.735a2.839 2.839 0 012.276-2.852 2.743 2.743 0 013.21 2.742v7.845c0 .378.306.686.685.686h3.428a.686.686 0 00.686-.686v-8.352zM5.485 8.914v13.714a.686.686 0 01-.686.686H1.37a.686.686 0 01-.685-.686V8.914c0-.379.307-.686.685-.686H4.8c.379 0 .686.307.686.686z",
    clipRule: "evenodd"
  });
};

exports.LinkedIn = LinkedIn;